import { useContext, useEffect, useRef } from 'react';
import ApplicationContext from '../ApplicationContext';

let countCheck = 0;

export default function useSideMenuHeightMonitor(name:string) {
  const appContext = useContext(ApplicationContext);
  const useDarkMode = appContext.useDarkMode;
  useEffect(() => {
    initialize();

    return uninitialize;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    adjustTableHeight();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appContext.appInfoAreaDrawerHeight, appContext.appInfoAreaContent, appContext.useDarkMode]);

  const observer = useRef<MutationObserver|null>(null);
  const infoAreaVisibleRef = useRef(false);
  const scrollPos = useRef(0);

  function initialize() {
    initializeEventListeners();
    initializeObserver();
  }

  function uninitialize() {
    uninitializeObserver();
    uninitializeEventListeners();
  }

  function initializeEventListeners() {
    window.addEventListener('resize', onScreenResize);
  }

  function uninitializeEventListeners() {
    window.removeEventListener('resize', onScreenResize);
  }

  function initializeObserver() {
    if (observer && observer.current) {
      return;
    }

    const sideMenuNode = document.getElementById('side-menu-operations-parent');
    if (!sideMenuNode) {
      return;
    }

    const observerConfig = {
      attributes: true,
      childList: true,
      subtree: true,
    };

    observer.current = new MutationObserver(observe);
    observer.current.observe(sideMenuNode, observerConfig);
  }

  function uninitializeObserver() {
    if (observer && observer.current) {
      observer.current.disconnect();
    }
  }

  function onScreenResize() {
    adjustTableHeight();
  }

  function observe() {
    // HACK - to avoid infinite loop in typescript. Research and find proper solution

    if (countCheck >= 100) {
      countCheck = 0;
      return;
    }
    
    ++countCheck;
    adjustTableHeight();
  }

  function adjustTableHeight() {
    const infoArea = document.getElementById('ifms-info-area-drawer');

    if (!infoAreaVisibleRef.current && infoArea && infoArea.dataset.open === 'true') {
      setTimeout(() => {
        captureTableScrollPosition();
        doAdjustTableHeight();
        scrollSelectedTableRowIntoView();
      }, 200); // To handle animations propely
    } else {
      const infoAreaWasOpened = !!infoAreaVisibleRef.current && infoArea && infoArea.dataset.open === 'false';
      doAdjustTableHeight();

      if (infoAreaWasOpened) {
        restoreTableScrollPosition();
      }
    }
  }

  function restoreTableScrollPosition() {
    const table = document.getElementById(name);
    if (!table) {
      return;
    }

    table.scrollTo({
      top: scrollPos.current,
      behavior: 'smooth'
    });
  }

  function captureTableScrollPosition() {
    const table = document.getElementById(name);
    if (!table) {
      return;
    }

    scrollPos.current = table.scrollTop;
  }

  function scrollSelectedTableRowIntoView() {
    const table = document.getElementById(name);
    if (!table) {
      return;
    }
    
    const selectedRows = table.getElementsByClassName( !useDarkMode ? 'ifms-side-menu-item-selected-onclick' : 'ifms-side-menu-item-selected-onclick-darkmode');
    if (!selectedRows || selectedRows.length <= 0) {
      return;
    }

    const selectedRow = selectedRows[0];

    selectedRow.scrollIntoView({behavior: 'smooth', block: 'end'});
  }

  function doAdjustTableHeight() {
    const table = document.getElementById(name);
    if (!table) {
      return;
    }

    const tableScrollbarHeight = table.getBoundingClientRect().height - table.clientHeight;

    let titleBarHeight = 0;
    let infoAreaHeight = 0;

    const titleBars = document.getElementsByClassName( !useDarkMode ? 'ifms-side-menu-operation-title' : 'ifms-side-menu-operation-title-darkmode');
    if (titleBars && titleBars.length > 0) {
      var tbRect = titleBars[0].getBoundingClientRect();
      titleBarHeight = tbRect.height;
    }

    const tobBars = document.getElementById('ifms-top-bar');
    if (tobBars) {
      tbRect = tobBars.getBoundingClientRect();
      titleBarHeight += tbRect.height;
    }

    const infoArea = document.getElementById('ifms-info-area-drawer');
    if (infoArea && infoArea.dataset.open === 'true') {
      infoAreaHeight = infoArea.clientHeight - tableScrollbarHeight; // In case info area is open don't make list appear above info area
      infoAreaVisibleRef.current = true;
    } else {
      infoAreaVisibleRef.current = false;
    }

    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

    table.style.height = `${vh - titleBarHeight - infoAreaHeight}px`;
  }

  return {
  };
}
  